<template>
	<div class="goods-form-wrapper">
		<div class="header-sidebar mb-4" slot="header">
			<h4 class="pull-left">
				<!--{{ $t('Create goods') }}-->
				{{ $t('sidebar.warehouse-management.sector') }}
			</h4>
			<b-button class="pull-right close-btn" @click="cancel" type="button" variant="link"><i
				class="fa fa-close"></i></b-button>
			<div class="clearfix"></div>
			<hr>
		</div>

		<form v-on:submit="create">
			<b-row>
				<b-col cols="5">
					<b-form-group
						breakpoint="lg"
						label-cols="4"
						label-size="sm"
						class=""
					>
						<template slot="label">
							FromSector <span class="text-danger"> * </span>
						</template>
						<b-form-input id="name"
									  size="sm"
									  name="name"
									  disabled
									  :placeholder="item.name + ' - ' + item.departmentName"></b-form-input>
					</b-form-group>
				</b-col>


				<b-col cols="5">
					<b-form-group
						breakpoint="lg"
						label-cols="4"
						label-size="sm"
						class=""
					>
						<template slot="label">
							ToSector <span class="text-danger"> * </span>
						</template>

						<b-form-select v-model="toSector"
									   :plain="false"
									   size="sm"
									   label-for="typeExpensesName"
									   :required="true"
									   :text-field="'name'"
									   :value-field="'id'"
						>
							<option v-for="(selectOption, indexOpt) in sectors"
									:key="indexOpt"
									:value="selectOption.id"
									:disabled="selectOption.id === item.id"
							>
								{{ selectOption.name}}
							</option>
							<template slot="first">
								<option :value="null" disabled>--
									SECTOR--
								</option>
							</template>
						</b-form-select>
					</b-form-group>

				</b-col>

			</b-row>

				<b-row class="mb-2">
					<b-col>
						<b-input-group size="sm" class="shadowed-group">
							<b-form-input size="sm" id="color"
										  v-model="wrappedSearchForm.keyword"
										  :placeholder="$t('incomes.search.search')">
							</b-form-input>
							<b-input-group-addon>
								<b-button @click="asyncFind">
									<i class="fa fa-search"></i>
								</b-button>
							</b-input-group-addon>
							<b-input-group-addon v-if="wrappedSearchForm.keyword.length>0">
								<b-button @click="clear">
									<i class="fa fa-close"></i>
								</b-button>
							</b-input-group-addon>

						</b-input-group>
					</b-col>

				</b-row>
				<div class="generalTableClass">

					<table class="table mt-1 generalTableClass">
						<thead>
						<tr>
							<th>&#9745;</th>
							<th>{{ $t('goods.name') }}</th>
							<th> {{ $t('goods.artikul') }}</th>
							<th> {{ $t('goods.color') }}</th>
							<th> {{ $t('goods.gender') }}</th>
							<th>{{ $t('goods.barcode') }}</th>
							<th>{{ $t('goods.amount') }}</th>
							<th>{{ $t('goods.amount') }}</th>
						</tr>
						</thead>
						<tbody>

						<tr v-for="product in productList">
							<td>
								<b-checkbox v-model="product.checked" @change="setItem($event, product)"></b-checkbox>
							</td>
							<td>
								<span>{{ product.item.name }}</span>
							</td>
							<td> {{ product.item.artikul }}</td>
							<td> {{ product.item.color.name }}</td>
							<td> {{ product.item.gender.name }}</td>
							<td> {{ product.item.barcode }}</td>
							<td> {{ product.remaining }}</td>
							<td>
								<b-form-input type="number" v-model="product.removeAmount" :id="product.id + '-id'" size="sm" @change="checkInput($event,product.remaining)" class="ml-1" :disabled="!product.checked"></b-form-input>
							</td>
						</tr>
						</tbody>
					</table>
					<nav>
						<b-pagination :total-rows="totalCount" :per-page="searchForm.limit" v-model="searchForm.page"
									  :prev-text="$t('pagination.prev')"
									  :next-text="$t('pagination.next')" hide-goto-end-buttons/>
					</nav>
				</div>
				<b-modal
					v-model="modalShow"
					@ok="create"
					@cancel="modalShow = !modalShow"
					ok-title="Да"
					cancel-title="Отмена"
				>
					<h4>Вы уверены?</h4>
				</b-modal>



			<div class="modal-actions">
				<b-row class="align-items-center">
					<b-col cols="6" class="mb-3 mb-xl-0">
						<b-row>
							<b-col cols="6">
								<b-button block size="sm" type="button" @click="cancel" variant="outline-danger">{{
									$t('cancel') }}
								</b-button>
							</b-col>
							<b-col cols="6">
								<b-button block type="button" size="sm" @click="confirm" variant="primary">{{$t('save') }}
								</b-button>
							</b-col>
						</b-row>
					</b-col>
				</b-row>
			</div>


		</form>
	</div>
</template>

<script>

import Multiselect from 'vue-multiselect'
import {TokenService} from "../../../services/storage.service";
import UsersService from "../../../services/users.sevice";
import WhDocument from "../../../services/wh-document.service";


export default {
		name: 'ControlSector',


		props: {
			item: {
				type: Object,
				default: null
			}

		},

		data: () => {
			return {
				wrappedSearchForm: {
					keyword: "",
				},
				fromDepartment:'',
				toSector: null,
				totalCount:10,
				sectors:[],
				productList: {},
				modalShow:false,
				searchForm:{
					page:1,
					limit:20
				}
			}
		},

		async created() {
			await this.getItemsList();
			await this.getDeps();
			await this.loadSector();
		},

		/**
		 * Methods
		 */
		methods: {
			create() {
				let data = []
				let vm = this;

				this.productList.forEach((el,index) => {
					if(el.checked){
						let obj = {}
						obj.itemStatusId = el.id;
						obj.remaining = parseInt(el.removeAmount);
						obj.sectorId = vm.toSector;
						data.push(obj);
					}

				});
				if(data.length > 0){
					this.$emit('save',data);
				}else{
					this.$vs.notify({
						title: this.$t('words.error'),
						text: this.$t('words.validation-error'),
						color: 'danger',
						icon: 'close',
						position: 'top-right'
					})
				}
			},

			confirm(){
				if(!this.toSector){
					this.$vs.notify({
						title: this.$t('words.error'),
						text: this.$t('words.validation-error'),
						color: 'danger',
						icon: 'close',
						position: 'top-right'
					})
				}else{
					this.modalShow = true;
				}

			},
			asyncFind() {
			},
			async getDeps()
			{
				await UsersService.getPermittedDepartments(TokenService.getCurrentUserId()).then(response => {
					this.departments =  response.data.permittedDepartments
				})
			},

			cancel() {
				this.$emit('close', true);
			},
			clear() {
				this.wrappedSearchForm.keyword = '';

			},
			async getItemsList(){

				this.searchForm.sector = this.item.id;
				await WhDocument.getItemsBySectorId(this.searchForm).then(response => {
					this.productList = response.items;
					this.totalCount = response.total;
				})

			},

			checkInput(event,allCount){
				if(event < 0 || event > allCount){
					this.$vs.notify({
						text: "Error",
						color: 'danger',
						icon: 'close',
						position: 'top-right'
					});
				}
			},
			setItem($event,item){
			},

			async loadSector() {
				await WhDocument.getSectorByDepartmentId(this.item.departmentId).then(response => {
					this.sectors = response;

				})
			},

		},

		computed: {},


		components: {
			Multiselect
		}
	}
</script>
<style scoped>

</style>
